/* eslint-disable @typescript-eslint/dot-notation */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Trolley } from '../data/new-models';
import { BaseResponse } from '../models/base.response';

const endpoints = {
  getTrolleyDetails: (flightGroupId: string) => '/trolley/detail/' + flightGroupId
};

@Injectable()
export class TrolleyService {

  constructor(
    private http: HttpClient
  ) { }

  async getTrolleyDetails(trolleyId: string): Promise<BaseResponse<Trolley>> {
    const url = environment.apiBaseUrl + endpoints.getTrolleyDetails(trolleyId);
    const res = await this.http.get<BaseResponse<Trolley>>(url).toPromise();
    return Promise.resolve(res);
  }


}
